<template>
  <div class="flex gap-6 border-b border-gray-200">
    <RouterLink
      v-for="(tab, index) in tabs"
      :key="index"
      :to="{ name: tab.route }"
      class="hover:border-gray -mb-px cursor-pointer border-b border-transparent py-4 font-medium"
      :class="{
        'border-primary! text-primary': $route.name.includes(tab.route),
        'cursor-default!': $route.name === tab.route,
      }"
    >
      <TextLabel class="flex items-center gap-2">
        {{ tab.name ?? "unknown" }}
      </TextLabel>
    </RouterLink>
  </div>
</template>

<script setup>
import { TextLabel } from "@repowerednl/ui-component-library"

defineProps({
  /**
   * Array of objects, each representing a tab. Structure should be:
   * [
   *   {
   *     name: "User",
   *     icon: "user", // Optional
   *     route: "user",
   *   },
   *   ...
   * ]
   */
  tabs: {
    type: Array,
    required: true,
  },
})
</script>
